import authReducer from "./Reducers/authReducer";
import categoryReducer from "./Reducers/categoryReducer";
import productReducer from "./Reducers/productReducer";
import sellerReducer from "./Reducers/sellerReducer";
import chatReducer from "./Reducers/chatReducer";
import OrderReducer from "./Reducers/OrderReducer";
import PaymentReducer from "./Reducers/PaymentReducer";
import dashboardIndexReducer from "./Reducers/dashboardIndexReducer";
import bannerReducer from "./Reducers/bannerReducer";
import specialityReducer from "./Reducers/specialityReducer";
import appointmentReducer from "./Reducers/appointmentReducer";
import blogReducer from "./Reducers/blogReducer";
import medicalFileReducer from "./Reducers/medicalFileReducer";

const rootReducer = {
  auth: authReducer,
  appointments: appointmentReducer,
  category: categoryReducer,
  speciality: specialityReducer,
  medicalFile: medicalFileReducer,
  blog: blogReducer,
  product: productReducer,
  seller: sellerReducer,
  chat: chatReducer,
  order: OrderReducer,
  payment: PaymentReducer,
  dashboardIndex: dashboardIndexReducer,
  banner: bannerReducer,
};
export default rootReducer;
